module.exports = __webpack_public_path__ + "img/05_WinthropLibrary.2f14a00d.jpg";